import sdl from '@jds/react-generated-sdl/JDSAvatarV2ProgressRing';
import type { JDSAvatarV2ProgressRingProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic } from '../logic';

const Component = (props: JDSAvatarV2ProgressRingProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    size = 'medium',
    disabled = false,
    ariaLabel = 'Avatar with Progress Activity Ring',
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    { size, disabled, ariaLabel, ...rest },
    'JDSAvatarV2ProgressRing',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const AvatarV2ProgressRing = withLogic(
  Component
) as React.FC<JDSAvatarV2ProgressRingProps> & { slotName?: string };

AvatarV2ProgressRing.displayName = 'AvatarV2ProgressRing';
AvatarV2ProgressRing.slotName = 'jds_avatar_v_2_progress_ring';

export { AvatarV2ProgressRing, type JDSAvatarV2ProgressRingProps };
